export default __webpack_public_path__ + "static/media/premiumVector.8b1b0352.svg";